import React from 'react';
import AlbumsDesktop from './AlbumsDesktop';
import AlbumsMobile from './AlbumsMobile';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <S.Header>
        <S.HeaderImageLegend>Foto: Bob Wolfenson</S.HeaderImageLegend>
        <S.ArrowIcon />
        <S.HeaderImage />
        <S.HeaderImageMobile />
      </S.Header>
      <S.Eye>
        <S.Title>
          Rap
          <br />
          do bom
        </S.Title>
        <S.EyeText>
          Dez discos clássicos do rap nacional contam a história de um gênero
          que se destaca cada vez mais no cenário artístico brasileiro. Aumente
          o volume.
        </S.EyeText>
        <S.EyeAuthor>Por Douglas Vieira</S.EyeAuthor>
      </S.Eye>
      <S.Content>
        <S.ContentText>
          <p>
            Mano Brown apresenta um dos mais interessantes podcasts de
            entrevista, o <i>Mano a mano</i>, no Spotify. Emicida está toda
            semana no <i>Papo de segunda</i>, do canal GNT. Os dois, que já são
            parte da história da música brasileira, extrapolam o rap e geram
            muitos outros negócios, uma consolidação que traz junto a força de
            gerações de artistas de enorme talento. Hoje, o hip-hop, além de
            música e cultura, é business, é comunicação, é a mais relevante
            narrativa moderna sobre o Brasil.
          </p>
          <p>
            Além da dupla acima, há rappers em abundância no país: Criolo,{' '}
            <a href="https://elle.com.br/depois-da-tempestade-2657107852">
              Karol Conká
            </a>
            , Sharylaine, Dexter, Nega Gizza, Tássia Reis, Negra Li, RZO, MV
            Bill, BNegão, Black Alien, Marcelo D2, Potencial 3, Thaíde e DJ Hum,
            Rappin' Hood, Marechal, Kamau, Drik Barbosa, Flora Matos,{' '}
            <a href="https://elle.com.br/de-frente-com-espelho">
              Baco Exu do Blues
            </a>
            , Djonga, Rincon Sapiência e muito mais gente.
          </p>
          <p>
            A seguir, uma seleção cuja intenção não é dizer quem são os melhores
            do gênero, gigante justamente por abraçar tantos estilos e olhares
            diversos. A ideia é lembrar trabalhos históricos do rap no Brasil,
            começando com duas coletâneas que apresentam as raízes do hip-hop
            nacional.
          </p>
        </S.ContentText>
        <AlbumsDesktop />
        <AlbumsMobile />
      </S.Content>
    </S.Container>
  );
};

export { Main };
